import gql from 'graphql-tag';

export { CREATE_NOTE } from './createNote';

const NOTE_FRAGMENT = gql`
	fragment note on Note {
		id
		description
		isAdminNote
		isImportant
		isPlanogramNote
		created
		creator {
			id
			username
			firstname
			lastname
			destroyed
		}
		modified
		modifier {
			id
			username
		}
	}
`;

export const GET_NOTES = gql`
	query(
		$page: Int!,
		$perPage: Int!,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: NotePageFilter
	) {
		getNotes(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				...note
			}
			count
		}
	}
	${NOTE_FRAGMENT}
`;

export const GET_NOTES_SUBSCRIPTION = gql`
	subscription ($input: NoteSubscriptionInput!) {
		NoteSubscription(input: $input) {
			note {
				...note
			}
		}
	}
	${NOTE_FRAGMENT}
`;

export const DESTROY_NOTE = gql`
	mutation destroyNoteMutation ($id: ID!) {
		destroyNote(id: $id)
	}
`;


export const GET_NOTE = gql`
	query($id: String) {
		getNote(id: $id) {
			...note
		}
	}
	${NOTE_FRAGMENT}
`;

export const MODIFY_NOTE = gql`
	mutation modifyNoteMutation($input: ModifyNoteInput!) {
		modifyNote(input: $input) {
			note {
				...note
			}
		}
	}
	${NOTE_FRAGMENT}
`;
